// eslint-disable-next-line no-restricted-imports
import { BaseDebtsDto_Input } from 'api/generated/graphql';
import { BaseDebtsEntity } from 'api/types/entity';

import { parsePrice } from '../../helpers/parsePrice';

export const parseClientRepresentativeDebtsParams = (
  data: BaseDebtsEntity
): BaseDebtsDto_Input => ({
  hasBankruptcyProceedings: data.hasBankruptcyProceedings,
  hasDelaysOrNonFulfillmentOfObligations:
    data.hasDelaysOrNonFulfillmentOfObligations,
  fees: data.fees ? parsePrice(data.fees) : undefined,
  finesForViolation: data.finesForViolation
    ? parsePrice(data.finesForViolation)
    : undefined,
  penalties: data.penalties ? parsePrice(data.penalties) : undefined,
  taxes: data.taxes ? parsePrice(data.taxes) : undefined,
});
